import { useMemo } from "react";
import { useRecommendationsContext } from "@/contexts/Recommendations/RecommendationsContext";
import type { StaffingIssue } from "@/utils/autoStaffing";
import type { DayItem, Recommendation } from "@/utils/models";

type useDayViewItemProps = {
	dayItem: DayItem;
	recommendations: StaffingIssue[];
};

export const useDayViewItem = ({ dayItem, recommendations: oldRecommendations }: useDayViewItemProps) => {
	const { recommendations } = useRecommendationsContext();

	const dayRecommendations: Recommendation[] = useMemo(
		() => recommendations.filter((rec) => rec.date.hasSame(dayItem.date, "day")),
		[recommendations, dayItem.date],
	);

	const dayIssues: StaffingIssue[] = useMemo(
		() => oldRecommendations.filter((rec) => rec.shiftTimes?.date?.hasSame(dayItem.date, "day")),
		[oldRecommendations, dayItem.date],
	);

	return { dayRecommendations, dayIssues };
};
